import { Mutation, Typenames } from '@varo/graphql-schema-types';
import { useRouter } from 'expo-router';
import { useEffect } from 'react';
import ReplaceLostStolenCard from 'services/graphql/mutations/ReplaceLostStolenCard';
import { getUuid } from 'shared/utils/getUuid/getUuid';
import { useMutation } from 'urql';

const useReplaceLostStolenCard = (cardId: string, cardType?: string) => {
  const router = useRouter();
  const [
    {
      fetching: replaceCardDataFetching,
      data: replaceCardData,
      error: replaceCardMutationError,
    },
    executeReplaceCardMutation,
  ] = useMutation<Mutation>(ReplaceLostStolenCard);

  const handleReplaceLostStolenCard = async () => {
    void (await executeReplaceCardMutation({
      idempotencyId: getUuid(),
      input: { cardId },
    }));
  };

  useEffect(() => {
    const replaceLostStolenCard = replaceCardData?.replaceLostStolenCard;
    if (
      !replaceCardMutationError &&
      replaceLostStolenCard?.__typename &&
      replaceLostStolenCard?.__typename in Typenames
    ) {
      router.replace({
        pathname: '/myvaro/card/replace-lost-stolen/new-card',
        params: {
          title: replaceLostStolenCard?.title,
          message: replaceLostStolenCard?.message,
          resultType: replaceLostStolenCard?.__typename,
          cardId: cardId,
          cardType: cardType,
        },
      });
    }
  }, [cardId, cardType, replaceCardData, replaceCardMutationError, router]);

  return {
    replaceCardDataFetching,
    replaceCardData,
    replaceCardMutationError,
    handleReplaceLostStolenCard,
  };
};

export default useReplaceLostStolenCard;
